export enum EnumTpEspecie {
    DuplicataMercantil = '1',
    NotaPromissoria = '2',
    NotaSeguro = '3',
    Recibo = '5',
    DuplicataServicos = '9',
    CartaoCredito = '31'
}